import { EditOutlined } from '@ant-design/icons';
import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { Link } from '@framework/ui/core/router/TypedRoute.tsx';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { getSubmissionPath } from './getSubmissionPath.ts';

export interface ISubmissionEditTableButtonProps {
  record: RichiestaDTO;
  isMobile?: boolean | null;
}

/**
 * Pulsante "compila il dettaglio della richiesta" all'interno della tabella delle richieste
 */
export function SubmissionEditTableButton(
  props: ISubmissionEditTableButtonProps,
) {
  const { record, isMobile } = props;

  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Link
      title={t(
        'submission-list.apri-pagina-compilazione-richiesta',
        'Apri la pagina di compilazione della richiesta',
      )}
      to={getSubmissionPath(theme.redirectToFirstModule, record.id)}
    >
      <Tooltip
        title={t('submission-list.compilazione-richiesta', 'Compila richiesta')}
      >
        <EditOutlined
          aria-hidden={!isMobile}
          aria-label={t(
            'submission-list.compilazione-richiesta',
            'Compila richiesta',
          )}
        />
      </Tooltip>
    </Link>
  );
}
